import request from '@/service/index'

//获取优惠卷列表
export function getcuponList(params){
    return request({
        url:'/music/coupon/former',
        method:'get',
        params
    })
}
//获取优惠卷下拉框
export function getcuponDrop(params){
    return request({
        url:'/select/couponDrop',
        method:'get',
        params
    })
}
//查询充值套餐列表
export function getsetmealList(){
    return request({
        url:'/music/setmeal/list2',
        method:'get'
    })
}
//新增充值记录
export function addRecords(data){
    return request({
        url:'/music/chargeRecords',
        method:'post',
        data
    })
}

/**---------------- 加入会员 ----------------------- */
//  查询会员套餐列表
export function vipRulesList(params){
    return request({
        url:'/music/vipRules/rulesList',
        method:'get',
        params
    })
}
// 冲会员页面可选优惠卷下拉框
export function getAddVipDrop(params){
    return request({
        url:'/select/getAddVipCouponDrop',
        method:'get',
        params
    })
}
//新增订单
export function addOthers(data){
    return request({
        url:'/music/order/add',
        method:'post',
        data
    })
}

/**---------------- 收藏  ----------------- */
//获取收藏列表
export function getCollectList(params){
    return request({
        url:'/music/collect/listUser',
        method:'get',
        params
    })
}

//取消收藏
export function cancelCollect(id){
    return request({
        url:`/music/collect/${id}`,
        method:'delete'
    })
}

/** ---------- 余额支付 ----------------- */
export function payAmount(num){
    return request({
        url:'/pay/amount?orderNum='+num,
        method:'post',
    })
}

/**------------ 免费求谱 ------------------- */
//免费求谱新增
export function postCustomize(data){
    return request({
        url:'/music/customize',
        method:'post',
        data
    })
}

//继续上传求谱
export function putCustomizeContinue(data){
    return request({
        url:'/music/customize/editContinue',
        method:'put',
        data
    })
}
//查询求谱列表
export function getCustomizeLsit(params){
    return request({
        url:'/music/customize/list',
        method:'get',
        params
    })
}
//求谱
export function addCustomize(data){
    return request({
        url:'/music/customize',
        method:'post',
        data
    })
}
//删除求谱记录
export function deleteCustomize(ids){
    return request({
        url:`/music/customize/${ids}`,
        method:'delete',
    })
}
//修改求谱
export function putCustomize(data){
    return request({
        url:'/music/customize',
        method:'put',
        data
    })
}
/**--------- ------- */
//修改用户头像昵称
export function updateUser(data){
    return request({
        url:'/system/user/nick',
        method:'put',
        data
    })
}
//获取兑换记录列表
export  function getRecodeList(params){
    return request({
        url:'/music/records/reception',
        method:'get',
        params
    })
}
//-----------------定制 -----------
export function addCustom(data){
    return request({
        url:'/music/custom',
        method:'post',
        data
    })
}
//定制页面可选优惠卷下拉框
export function getCoupDrop(params){
    return request({
        url:'/select/getAddCouponDrop',
        method:'get',
        params
    })
}

//---------- 上传作品 -----------
export function addMusicWord(data){
    return request({
        url:'/music/musicWord',
        method:'post',
        data
    })
}
//查询用户上传列表
export function getmusicWordList(params){
    return request({
        url:"/music/musicWord/uploadList",
        method:"get",
        params
    })
}
//查询曲谱/音频/视频类别下拉框
export function getCategoryDrop(){
    return request({
        url:'/select/categoryDrop',
        method:'get'
    })
}
//...类型下拉框
export function getScoreDrop(params){
    return request({
        url:'/select/scoreDrop',
        method:'get',
        params
    })
}

/**------积分 ------- */
export function getGoodsList(params){
    return request({
        url:'/music/goods/list',
        method:'get',
        params
    })
}

//查询邀新记录列表
export function getInviteRecords(params){
    return request({
        url:'/music/inviteRecords/listInvite',
        method:'get',
        params
    })
}
//填写邀请码
export function addInviteRecod(data){
    return request({
        url:'/music/inviteRecords/add',
        method:'post',
        data
    })
}

//邀新奖励下拉框
export function inviteRecordeDrop(params){
    return request({
        url:'/music/inviteRecords/rewardDrop',
        method:'get',
        params
    })
}
//提交获取奖励
export function inviteRecodeSelect(data){
    return request({
        url:'/music/inviteRecords/selectReward',
        method:'put',
        data
    })
}

//我的订单列表
export function myOtherList(params){
    return request({
        url:'/music/order/volist',
        method:'get',
        params
    })
}

//查询邀新套餐列表
export function getinviteMealList(){
    return request({
        url:'/music/inviteMeal/list',
        method:'get'
    })
}
//微信支付返回二维码地址
export function getWeChat(params){
    return request({
        url:'/wechat/wx',
        method:'get',
        params
    })
}
//查询订单是否支付成功
export function getOtherStatus(params) {
    return request({
        url:'/wechat/order',
        method:'get',
        params
    })
}
//支付宝支付/alipay/pay,/alipay/phonePay
export function payZFB(data){
    return request({
        url:'/alipay/pay',
        method:'post',
        headers:{
            'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data
    })
}
// 手机端支付宝支付
export function payzfbPhone(data){
    return request({
        url:'/alipay/phonePay',
        method:'post',
        headers:{
            'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data
    })
}



//微信登录绑定手机号
export function wechatWxPhone(data){
    return request({
        url:'/wechat/wxPhone',
        method:'post',
        data
    })
}
//绑定微信扫描二维码
export function bindingWx(){
    return request({
        url:'/wechat/bindingWx',
        method:'get'
    })
}
export function inviteCode(){
    return request({
        url:'/music/inviteMeal/produce',
        method:'get'
    })
}
export function imgList(){
    return request({
        url:'/music/banner/member',
        method:'get'
    })
}
export function VipUpload(){
    return request({
        url:'/music/vip/vip',
        method:'get'
    })
}
export function cancelorder(data){
    return request({
        url:'/music/order/cancelOrder',
        method:'post',
        data
    })
}
// 微信支付
export function wxPay(orderNum){
    return request({
        url:'/wechat/wx?orderNum='+orderNum,
        method:'get'
    })
}
// h5微信支付
export function wxHPay(orderNum){
    return request({
        url:'/wechat/wxpay/v3/h5Pay?outTradeNo='+orderNum,
        method:'get'
    })
}
// pc订单查询
export function paySearch(orderNum){
    return request({
        url:'/wechat/wxpay/v3/searchJsApi?tradeNo='+orderNum,
        method:'get'
    })
}
